import { createContext } from "react";

const HarvestingProceduresContext = createContext();

export default HarvestingProceduresContext;